"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KettePropertiesCompact = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Kette properties that are used by the individual applications compact requests.
 */
class KettePropertiesCompact {
}
exports.KettePropertiesCompact = KettePropertiesCompact;
_a = echain_shared_igus_fundamentals_1.AppName.TEST, _b = echain_shared_igus_fundamentals_1.AppName.EIQ, _c = echain_shared_igus_fundamentals_1.AppName.EKE, _d = echain_shared_igus_fundamentals_1.AppName.EIC, _e = echain_shared_igus_fundamentals_1.AppName.ECF;
KettePropertiesCompact[_a] = [];
KettePropertiesCompact[_b] = [
    'Id',
    'EchainId',
    'AdapterLinkRef',
    'ApproxGewichtKgProM',
    'ApproxVerfahrwegToEffektiveLaenge',
    'ArtNr',
    'ArticleSpecs',
    'ArticleType',
    'Aussenbreite',
    'Aussenhoehe',
    'AutoglideLinkRef',
    'Bezeichnung',
    'Biegeradius',
    'ContractedLength',
    'EchainSystem',
    'EcpRef',
    'EcwRefs',
    'EffektiveLaenge',
    'FreigabeEIQ',
    'HasFixedLength',
    'IndexBiegeradius',
    'IndexBreite',
    'Innenbreite',
    'Innenhoehe',
    'IproProduktgruppenId',
    'K2',
    'KetteSerieType',
    'LeitungDiameterMax',
    'MaxCablesPerChamber',
    'ModifiedLinkRef',
    'MontagesetRef',
    'NumFirstOtherLinks',
    'NumGlieder',
    'OpeningPrinciple',
    'RadiusAussen',
    'RinneRef',
    'RinnenvarianteRef',
    'RolLinkRef',
    'Rotationswinkel',
    'SerieRef',
    'SmartPlasticsECWAllowed',
    'StandardLinkRef',
    'Teilung',
    'TrxeVariant',
];
KettePropertiesCompact[_c] = [
    'Id',
    'EchainId',
    'ApproxGewichtKgProM',
    'ApproxVerfahrwegToEffektiveLaenge',
    'ArtNr',
    'ArticleSpecs',
    'ArticleType',
    'Aussenbreite',
    'Aussenhoehe',
    'Bauform',
    'BelastungFLB',
    'BelastungFLG',
    'BelastungGleitendMaxWeightUntilSpeed',
    'BeschleunigungFLBMax',
    'BeschleunigungFLGMax',
    'BeschleunigungGleitendMax',
    'BeschleunigungHaengendMax',
    'Bezeichnung',
    'Biegeradius',
    'ContractedLength',
    'D',
    'D1',
    'EchainSystem',
    'EffektiveLaenge',
    'EinbauartFreitragendErlaubt',
    'EinbauartGleitendErlaubt',
    'EinbauartHaengendErlaubt',
    'EinbauartHaengendMax',
    'EinbauartLangeVerfahrwege',
    'FZGleitendMax',
    'FreigabeEIC',
    'FreigabeEKE',
    'FreigabeEKEManualMode',
    'GeschwindigkeitFLBMax',
    'GeschwindigkeitFLGMax',
    'GeschwindigkeitGleitendMax',
    'GeschwindigkeitHaengendMax',
    'GewichtKgProM',
    'GleitenderBetriebErlaubt',
    'H',
    'HasFixedLength',
    'HoeheVorspannung',
    'IndexBiegeradius',
    'IndexBreite',
    'Innenbreite',
    'Innenhoehe',
    'IproProduktgruppenId',
    'K',
    'K2',
    'K3',
    'KetteSerieType',
    'LeitungDiameterMax',
    'MaxAELaenge',
    'MaxCablesPerChamber',
    'MinBauraumGleitendRinneRefs',
    'MontagesetRef',
    'NumGlieder',
    'OpeningPrinciple',
    'OpeningPrincipleLabel',
    'PushPullForceMax',
    'RadiusAussen',
    'RinneRef',
    'RolLinkRef',
    'Rotationswinkel',
    'SerieRef',
    'SerienKurzbezeichnung',
    'SmartPlasticsECWAllowed',
    'Teilung',
    'TrxeVariant',
    'TemperaturMax',
    'TemperaturMin',
    'WidenBildId',
    'WidenZeichnungId',
    'X1',
];
KettePropertiesCompact[_d] = [
    'Id',
    'EchainId',
    'ApproxGewichtKgProM',
    'ApproxVerfahrwegToEffektiveLaenge',
    'ArtNr',
    'ArticleSpecs',
    'ArticleType',
    'Bezeichnung',
    'Biegeradius',
    'ContractedLength',
    'EffektiveLaenge',
    'FreigabeEIC',
    'FreigabeEKE',
    'GewichtKgProM',
    'HasFixedLength',
    'IndexBiegeradius',
    'IndexBreite',
    'Innenhoehe',
    'IproProduktgruppenId',
    'KetteSerieType',
    'MaxCablesPerChamber',
    'NumGlieder',
    'OpeningPrinciple',
    'RadiusAussen',
    'Rotationswinkel',
    'SerieRef',
    'TrxeVariant',
];
KettePropertiesCompact[_e] = ['Id', 'EchainId'];
//# sourceMappingURL=KettePropertiesCompact.js.map